import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1.5 12.5V9.10263L4.19982 2.80304C4.27861 2.6192 4.45938 2.5 4.6594 2.5H11.3406C11.5406 2.5 11.7214 2.6192 11.8002 2.80304L14.5 9.10263V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5H2.5C1.94772 13.5 1.5 13.0523 1.5 12.5Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.5 9H4.69098C4.88037 9 5.0535 9.107 5.1382 9.27639L5.8618 10.7236C5.9465 10.893 6.11963 11 6.30902 11H9.69098C9.88037 11 10.0535 10.893 10.1382 10.7236L10.8618 9.27639C10.9465 9.107 11.1196 9 11.309 9H14.5"
            stroke="currentColor"
        />
    </svg>
);

export default Icon;
